import React, { useRef, useContext } from "react";
import { LoadingContext } from "../context/LoadingContext";
import near from "../../images/home/Partners/nearPartner.png";
import corebi from "../../images/home/Partners/corebiPartner.png";
import mp from "../../images/home/Partners/MicrosoftPartner.png";
import insurtech from "../../images/home/Partners/insurtechParnter.png";
import i18n from "i18next";
import Slider from "react-slick";

const Partners = () => {
  const { windowWidth } = useContext(LoadingContext);
  const carouselRef = useRef(null);

  const imagesArr = [
    { image: near, texto: "1" },
    { image: corebi, texto: "1" },
    { image: mp, texto: "1" },
    { image: insurtech, texto: "1" },
  ];

  const settings = {
    infinite: true,
    speed: 4000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true, 
    autoplaySpeed: 0,
    cssEase: "linear",
    arrows: false,
    dots: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          speed: 4000,
        },
      },
    ],
  };

  return (
    <div className="mobile:w-full desktop:pl-8 desktop:pr-4 mobile:pl-4 mobile:pr-4 flip-card bannerCertification">
      <div className="lineSeparator"></div>
      {windowWidth >= 1025 ? (
        <div className="flip-card-inner2 mt-24 mb-24">
          <div className="mobile:w-full mobile:pl-16 mobile:mb-4 landscape:mb-0 landscape:w-full desktop:pr-4 mobile:pr-16">
            <p className="titleCompanies">{i18n.t("home.partners.title")}</p>
          </div>

          <div className="flex targetExperts mt-12 justifyStyle">
            {imagesArr.map((item, i) => (
              <div className="contentTargetExperts" key={i}>
                <div className="m-auto">
                  <img
                    src={item.image}
                    alt="...."
                    className="imgCardCertPart"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div className="flip-card-inner2 mt-24 mb-24">
          <div className="mobile:w-full mobile:mb-4 landscape:mb-0 landscape:w-full desktop:pr-4 mobile:pr-16">
            <p className="titleCompanies">{i18n.t("home.partners.title")}</p>
          </div>

          <div className="mt-12 justifyStyle">
            <Slider
              ref={carouselRef}
              {...settings}
              className="rounded-sm mx-2 py-10"
            >
              {imagesArr.map((item, i) => (
                <div className="contentTargetExpertsMobile2" key={i}>
                  <div className="m-auto">
                    <img
                      src={item.image}
                      alt="...."
                      className="imgCardCertification22"
                    />
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      )}
    </div>
  );
};

export default Partners;
